
import React, { Component } from "react";
import almostEqual from "almost-equal";
import { Input } from 'reactstrap';
const RuleType = {
    Number: 1,
    Range: 2,
    GreaterThen: 3,
    LessThen: 4
};

function getRules(value) {
    let rules = [];
    if (value === '') {
        return rules;
    }
    // check comma
    let list = value.split(',');
    if (list.length > 0) {
        // handle each value with comma
        for (let key in list) {
            if (!list.hasOwnProperty(key)) {
                continue;
            }

            let obj = list[key];
            if (obj.indexOf('-') > 0) { // handle dash
                let begin = parseInt(obj.split('-')[0], 10);
                let end = parseInt(obj.split('-')[1], 10);
                rules.push({ type: RuleType.Range, begin: begin, end: end });
            } else if (obj.indexOf('>') > -1) { // handle greater then
                let begin = parseInt(obj.split('>')[1], 10);
                rules.push({ type: RuleType.GreaterThen, value: begin });
            } else if (obj.indexOf('<') > -1) { // handle less then
                let end = parseInt(obj.split('<')[1], 10);
                rules.push({ type: RuleType.LessThen, value: end });
            } else { // handle normal values
                let numericValue = parseInt(obj, 10);
                rules.push({ type: RuleType.Number, value: numericValue });
            }
        }
    }
    return rules;
}

export const NumericFilter = ({filter, onChange}) => {
    return(<Input
      onChange={event => onChange(event.target.value)}     
      value={filter ? filter.value : "" }
      placeholder=">20,<25,100"
    />);

}

export const numericFilter = (filter, row) => {
    console.log(filter);
    console.log(row);

    let result = false;
    let value = parseFloat(row[filter.id]);
    let rules = getRules(filter.value);

    for (let i =0; i < rules.length; i++) {
        let rule = rules[i];
        switch (rule.type) {
            case RuleType.Number:
                if (almostEqual(rule.value, value, .001, .001))
                    //rule.value === value) 
                {
                    result = true;
                }
                break;
            case RuleType.GreaterThen:
                if (rule.value <= value) {
                    result = true;
                }
                break;
            case RuleType.LessThen:
                if (rule.value >= value) {
                    result = true;
                }
                break;
            case RuleType.Range:
                if (rule.begin <= value && rule.end >= value) {
                    result = true;
                }
                break;
            default:
                // do nothing
                break;
        }
    }
   return result;
}

export const textFilter = (filter, row) => {
    let result = false;
    let value = row[filter.id];

    let regex = new RegExp(filter.value, 'i');
    return regex.test(value);
 
}


// WEBPACK FOOTER //
// ./src/lib/tableFilters.js